'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _urls = require('../../utils/urls');

var _components = require('../../components');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CoverLots = require('./CoverLots.scss');

var _CoverLots2 = _interopRequireDefault(_CoverLots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoverLots = (_temp = _class = function (_PureComponent) {
    (0, _inherits3.default)(CoverLots, _PureComponent);

    function CoverLots() {
        (0, _classCallCheck3.default)(this, CoverLots);
        return (0, _possibleConstructorReturn3.default)(this, (CoverLots.__proto__ || (0, _getPrototypeOf2.default)(CoverLots)).apply(this, arguments));
    }

    (0, _createClass3.default)(CoverLots, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                catalogUrl = _props.catalogUrl,
                className = _props.className,
                coverLots = _props.coverLots,
                featured = _props.featured,
                sellerId = _props.sellerId;
            var catalogId = coverLots.catalogId,
                results = coverLots.results;

            var _results = (0, _slicedToArray3.default)(results, 3),
                _results$ = _results[0],
                item1 = _results$ === undefined ? {} : _results$,
                _results$2 = _results[1],
                item2 = _results$2 === undefined ? {} : _results$2,
                _results$3 = _results[2],
                item3 = _results$3 === undefined ? {} : _results$3;

            var coverLotImgAlt1 = item1.title;
            var coverLotImgAlt2 = item2.title;
            var coverLotImgAlt3 = item3.title;

            var coverLotImgSrc1 = (0, _urls.getCoverLotPrimaryImageUrl)(sellerId, catalogId, item1.itemId, 1, item1.imageVersion, featured);
            var coverLotImgSrc2 = (0, _urls.getCoverLotSecondaryImageUrl)(sellerId, catalogId, item2.itemId, 1, item2.imageVersion, featured);
            var coverLotImgSrc3 = (0, _urls.getCoverLotSecondaryImageUrl)(sellerId, catalogId, item3.itemId, 1, item3.imageVersion, featured);

            var coverLotImgHref1 = void 0,
                coverLotImgHref2 = void 0,
                coverLotImgHref3 = void 0;
            if (catalogUrl) {
                coverLotImgHref1 = catalogUrl;
                coverLotImgHref2 = catalogUrl;
                coverLotImgHref3 = catalogUrl;
            } else {
                coverLotImgHref1 = (0, _urls.getItemUrl)(item1.itemId, item1.title);
                coverLotImgHref2 = (0, _urls.getItemUrl)(item2.itemId, item2.title);
                coverLotImgHref3 = (0, _urls.getItemUrl)(item3.itemId, item3.title);
            }

            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_CoverLots2.default['cover-lots']]).join(' ').trim();

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: coverLotImgHref1,
                className: _CoverLots2.default['primary-img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.primary,
                src: coverLotImgSrc1,
                alt: coverLotImgAlt1
            })), (0, _jsx3.default)('div', {
                className: _CoverLots2.default['secondary-img-container']
            }, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: coverLotImgHref2,
                className: _CoverLots2.default['img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.secondary,
                src: coverLotImgSrc2,
                alt: coverLotImgAlt2
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: coverLotImgHref3,
                className: _CoverLots2.default['img-container']
            }, void 0, (0, _jsx3.default)(_components.ImageWithFallback, {
                className: _CoverLots2.default.secondary,
                src: coverLotImgSrc3,
                alt: coverLotImgAlt3
            }))));
        }
    }]);
    return CoverLots;
}(_react.PureComponent), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = CoverLots;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CoverLots/CoverLots.js
// module id = L9QP
// module chunks = 46